/* import __COLOCATED_TEMPLATE__ from './sms-segment-info-component.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import { SegmentedMessage } from 'sms-segments-calculator';
import normalizeForGsm7 from 'embercom/lib/sms/normalize-gsm-characters';

export default class SmsSegmentInfoComponent extends Component {
  get segmentedMessage() {
    let text = this.args.blocks
      .map((block, index) => {
        if (block.type === 'paragraph' && index !== this.args.blocks.length - 1) {
          return `${block.text}\n`;
        } else {
          return block.text;
        }
      })
      .join('');
    return new SegmentedMessage(normalizeForGsm7(text));
  }

  get numberSegments() {
    return this.segmentedMessage.segmentsCount;
  }

  get textLength() {
    return this.segmentedMessage.numberOfCharacters;
  }
}
